module.exports = __webpack_public_path__ + "static/media/html-css-javascript-lg.54fd4234.jpg";